<script setup>
import { useNotificationsStore } from '@/stores/NotificationsStore'
import { useRouter, useRoute } from 'vue-router'
import NotificationItemButton from '@/views/Notifications/components/NotificationItemButton.vue'
import { timeAgo } from '@/helpers/times'

const props = defineProps({
  getter: { type: String, required: true },
  type: { type: String, required: true },
  readableState: { type: Boolean, default: true }
})

const notificationsStore = useNotificationsStore()

const router = useRouter()

const handleClick = (job) => {
  if (props.type === 'preview') {
    router.push(`/notifications`)
    return
  }

  !job.isRead && notificationsStore.markAsRead(job.id)
}
</script>
<template>
  <div 
    v-for="job in notificationsStore[getter]"
    :key="job.id" 
    class="flex gap-3 border-b border-gray-200 py-2 px-3 last:border-b-0 w-full flex-col cursor-pointer relative"
    :class="{ 'bg-gray-50': !job.isRead && type === 'notification', '!cursor-default': type === 'notification' && job.isRead, 'py-4': type === 'notification' }"
    @click="() => handleClick(job)"
  >
    <div class="absolute top-3 right-3 h-2 w-2 bg-tint-1 rounded-full" v-if="!job.isRead && type === 'notification'" />

    <div class="flex items-start gap-x-3 ">
      <div class="w-9 h-9">
        <img v-if="job.channel" :src="job.channel.logo" class="w-9 h-9 object-contain" />
      </div>
      
      <div class="flex flex-col gap-y-1 w-full">
        <div class="flex justify-between w-full">
          <span v-if="job.channel" class="text-xs text-gray-900 font-semibold">{{ type === 'preview' ? `${job.channel.name} ${job.message}` : type === 'job' ? job.channel.name : job.message }} </span>
          <Icon v-if="type === 'notification' && job.isRead" icon="heroicons:x-mark" class="text-base ml-auto" @click.stop.prevent="notificationsStore.deleteNotification(job.id)" />
        </div>
        <div class="flex items-center gap-x-1">
          <span class="text-xs font-normal text-gray-600">{{ ['job'].includes(type) ? job.message : job.description }} </span>
        </div>
        
        <div class="flex gap-4 items-center" v-if="type === 'job'">
          <div class="w-full h-2 bg-gray-200 rounded-full overflow-hidden">
              <div
                class="h-full rounded-full bg-tint-1 transition-all duration-300"
                :style="{ width: (job.progress || 0) + '%' }"
              ></div>
            </div>
            <span class="min-w-[40px] text-tint-1 font-medium text-xs text-right">{{ (job.progress || 0) }}%</span>
        </div>

        <div v-if="job.images?.length" class="flex">
          <div v-for="image in job.images" :key="image">
            <img :src="image" class="w-8 h-10 object-contain" />
          </div>
        </div>

        <div v-if="type === 'notification'">
          <!-- <div class="flex items-center gap-x-1 justify-between w-full" v-if="job.type.includes('failed')">
            <div class="flex items-center gap-x-1 text-xs py-[6px] px-2 rounded-md bg-pink-100">
              <Icon icon="heroicons:exclamation-circle" class="text-base text-pink-900" />
              <span class="text-xs text-pink-900">Failed with errors</span>
            </div>
            <span class="text-xs text-tint-1 hover:underline cursor-pointer">See Details </span>
          </div> -->
          <!-- <div class="flex items-center gap-x-1 text-xs py-[6px] px-2 rounded-md bg-green-100 w-fit">
            <Icon icon="heroicons:check-circle" class="text-base text-green-900" />
            <span class="text-xs text-green-900">Completed</span>
          </div> -->

          <NotificationItemButton 
            :type="job.type"
            :id="job.id"
          />
        </div>

        <span v-if="type === 'notification'" class="text-xs font-normal text-gray-600">{{ timeAgo(job.createdAt) }} </span>
        
      </div>     
    </div> 
  </div>
</template>
<style scoped>
@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

.animate-pulse {
  animation: pulse 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
</style>